export const FormHook = ({ handleSubmit, submit, className, children }) => {
  return (
    <form
      onSubmit={handleSubmit(submit)}
      className={`relative bg-white shadow-md rounded p-6 flex flex-col ${className}`}
    >
      <span className="absolute top-0 right-2 text-xs">Campos con <strong className="text-xl text-red-500">*</strong> son requeridos</span>
      {children}
    </form>
  );
};
